
            //convierte a bullets
     document.addEventListener("DOMContentLoaded", function() {
    const description = document.querySelector('.product-description-standard');
    if (!description) return;

    // Función para corregir caracteres especiales
    function fixText(html) {
      return html.replace(/—/g, 'ó')
                 .replace(/–/g, 'ñ')
                 .replace(/‡/g, 'á')
                 .replace(/Ž/g, 'é');
    }

    // Función recursiva que envuelve en <strong> cualquier palabra que termine en ":"
    function wrapLabelsInNode(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        const regex = /([\wÁÉÍÓÚáéíóúÑñ]+:)/g;
        let text = node.nodeValue;
        let match, lastIndex = 0;
        const frag = document.createDocumentFragment();
        while ((match = regex.exec(text)) !== null) {
          // Agrega el texto anterior al match
          if (match.index > lastIndex) {
            frag.appendChild(document.createTextNode(text.substring(lastIndex, match.index)));
          }
          // Crea el elemento <strong> con el texto encontrado
          const strong = document.createElement('strong');
          strong.textContent = match[1];
          frag.appendChild(strong);
          lastIndex = regex.lastIndex;
        }
        // Agrega el texto que queda
        if (lastIndex < text.length) {
          frag.appendChild(document.createTextNode(text.substring(lastIndex)));
        }
        node.parentNode.replaceChild(frag, node);
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        // Si el elemento ya es <strong>, no se procesa para evitar dobles envolturas
        if (node.tagName.toLowerCase() === 'strong') return;
        // Recorre recursivamente sus hijos
        Array.from(node.childNodes).forEach(child => wrapLabelsInNode(child));
      }
    }

    // Función que procesa el HTML: corrige caracteres y envuelve etiquetas de labels
    function processHTML(originalHTML) {
      let fixedHTML = fixText(originalHTML);
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = fixedHTML;
      wrapLabelsInNode(tempDiv);
      return tempDiv.innerHTML;
    }

    // Si ya existe una lista de bullets, solo corrige cada <li>
    const bulletList = description.querySelector('ul, ol');
    if (bulletList) {
      Array.from(bulletList.querySelectorAll('li')).forEach(li => {
        li.innerHTML = processHTML(li.innerHTML);
      });
    } else {
      // Si no hay bullets, convierte cada párrafo en un <li> dentro de una lista
      const paragraphs = Array.from(description.querySelectorAll('p'));
      if (paragraphs.length > 0) {
        const ul = document.createElement('ul');
        paragraphs.forEach(p => {
          const li = document.createElement('li');
          li.innerHTML = processHTML(p.innerHTML);
          ul.appendChild(li);
          p.remove();
        });
        description.appendChild(ul);
      }
    }
  });




              document.addEventListener('DOMContentLoaded', function() {
                // Seleccionamos TODOS los botones de compartir mediante la clase
                var shareButtons = document.querySelectorAll('.share-button');
                var shareModal = document.getElementById('share-modal');
                var closeModal = document.querySelector('.share-modal-close');

                // Agregamos el evento a cada botón
                shareButtons.forEach(button => {
                  button.addEventListener('click', function() {
                    shareModal.style.display = 'flex'; // Muestra el modal y lo centra
                  });
                });

                // Evento para cerrar el modal al hacer clic en la "x"
                closeModal.addEventListener('click', function() {
                  shareModal.style.display = 'none';
                });

                // Cierra el modal si se hace clic fuera de la ventana de contenido
                window.addEventListener('click', function(event) {
                  if (event.target === shareModal) {
                    shareModal.style.display = 'none';
                  }
                });
              });

